(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["custom-index_section"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
        function setSlick() { 
            if (!$('.collection-selector_content--item .grid:visible').hasClass('slick-slider')) {
                if (window.innerWidth > 767) {
                    $('.collection-selector_content--item .grid:visible').slick({
                        infinite: false,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                        responsive: [
                            {
                                breakpoint: 700,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    infinite: false
                                }
                            }
                        ]
                    });
                } else {
                    $('.collection-selector_content--item .grid:visible').slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true
                    });
                }
            }
        }

        $('.selector').on('click', function () {
            $(this).closest('.collection-selector_wrapper').toggleClass('second');
            setSlick();
        });

        setTimeout(function () {
            setSlick(); 
        }, 500);
    });

  } catch(e) { console.error(e); }
})();
      })();
